<template>
  <div class="full-wrapper pannel">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <component :is="currentView" :active="active"/>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import WHostClusterView from './components/HostClusterView';
import WHostView from './components/HostView';
import WVmView from './components/VmView';
import WStorageClusterView from './components/StorageClusterView';
import WStorageView from './components/StorageView';
import WKvmHostView from './components/KvmHostView';
import WKvmVmView from './components/KvmVmView';
import WHypervHostClusterView from './components/HypervHostClusterView';
import WHypervHostView from './components/HypervHostView';
import WHypervVmView from './components/HypervVmView';
import WXenHostClusterView from './components/XenHostClusterView';
import WXenHostView from './components/XenHostView';
import WXenVmView from './components/XenVmView';
import WRhevHostClusterView from './components/RhevHostClusterView';
import WRhevHostView from './components/RhevHostView';
import WRhevVmView from './components/RhevVmView';

export default {
  name: 'WPerformanceVirtualSummary',
  mixins: [ScrollbarMixin],
  components: {
    WHostClusterView,
    WHostView,
    WVmView,
    WStorageClusterView,
    WStorageView,
    WKvmHostView,
    WKvmVmView,
    WHypervHostClusterView,
    WHypervHostView,
    WHypervVmView,
    WXenHostClusterView,
    WXenHostView,
    WXenVmView,
    WRhevHostClusterView,
    WRhevHostView,
    WRhevVmView,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  mounted() {
    this.setScrollData();
  },
  watch: {
    selectedNode: {
      handler() {
        this.changeView();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.changeView();
      },
    },
  },
  methods: {
    changeView() {
      if (this.selectedNode) {
        // hypervisor - VMWARE
        if (this.selectedNode.hypervisorType === 'VMWARE') {
          if (this.selectedNode.obj.objtypeId === 'VCL') {
            this.currentView = WHostClusterView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VHO') {
            this.currentView = WHostView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VVM') {
            this.currentView = WVmView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VDSC') {
            this.currentView = WStorageClusterView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VDS') {
            this.currentView = WStorageView.name;
          }
          // hypervisor - KVM
        } else if (this.selectedNode.hypervisorType === 'KVM') {
          if (this.selectedNode.obj.objtypeId === 'VHO') {
            this.currentView = WKvmHostView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VVM') {
            this.currentView = WKvmVmView.name;
          }
          // hypervisor - HYPERV
        } else if (this.selectedNode.hypervisorType === 'HYPERV') {
          if (this.selectedNode.obj.objtypeId === 'VCL') {
            this.currentView = WHypervHostClusterView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VHO') {
            this.currentView = WHypervHostView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VVM') {
            this.currentView = WHypervVmView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VDS') {
            this.currentView = WStorageView.name;
          }
          // hypervisor - XenServer
        } else if (this.selectedNode.hypervisorType === 'XENSERVER') {
          if (this.selectedNode.obj.objtypeId === 'VCL') {
            this.currentView = WXenHostClusterView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VHO') {
            this.currentView = WXenHostView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VVM') {
            this.currentView = WXenVmView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VDS') {
            this.currentView = WStorageView.name;
          }
        } else if (this.selectedNode.hypervisorType === 'RHEV') {
          if (this.selectedNode.obj.objtypeId === 'VCL') {
            this.currentView = WRhevHostClusterView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VHO') {
            this.currentView = WRhevHostView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VVM') {
            this.currentView = WRhevVmView.name;
          } else if (this.selectedNode.obj.objtypeId === 'VDS') {
            this.currentView = WStorageView.name;
          }
        }
      }
    },
    loadData() {
      // if (this.active) {
      // }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/virtual/index.vue